export default "__VITE_ASSET__CLEEyrCL__"